module.exports = __webpack_public_path__ + "static/media/logo.00f3a279.png";